import { useMemo } from 'react';
import { Config } from '@copilot/common/config';
import { isNonEmptyArray } from '@apollo/client/utilities';

const getDiscriptionContent = () => {
    if (!Config.isAgency) {
        const practices = !Config.clickAndSendSupportURL
            ? {
                  header: 'Best practices for creating quick responses to get more positive responses:',
                  body: [
                      'Keep it short (5 sentences max)',
                      'Keep it clear (if you confuse prospects you lose them)',
                      'Keep it conversational',
                      'Add a call to action',
                      'Add a discovery question',
                      'Add your calendar link',
                      "Ask for prospect's email address or phone number",
                  ],
              }
            : {
                  header: 'Need help crafting Quick Responses that get results?',
                  body: [],
              };
        const useCases = !Config.clickAndSendSupportURL
            ? {
                  header: 'Best use cases for creating quick responses:',
                  body: [
                      'Prospect is interested at a later date',
                      'Prospect is interested now',
                      'Prospect is not interested',
                      'Prospect is not the right person',
                      'Prospect is neutral',
                  ],
              }
            : undefined;
        return {
            Introduction: `
Set up templates for your most common replies. Once saved, your Quick Responses will be available in your inbox, making it easy to send proven replies in seconds.

		`,
            Practices: practices,
            UseCases: useCases,
        };
    }

    return {
        Introduction: `
Set up templates for your most common replies. Once saved, your Quick Responses will be available in your inbox, making it easy to send proven replies in seconds.
        `,
        Practices: {
            header: 'Best practices:',
            body: [
                'Keep templates short and conversational',
                'Ask for emails and numbers',
                'Always include clear next steps',
                'Include your calendar link',
            ],
        },
        UseCases: {
            header: 'Best use cases:',
            body: ['Interested later', 'Interested now', 'Not interested', 'Neutral response'],
        },
    };
};

export const TemplateDescription = () => {
    const content = useMemo(
        () => getDiscriptionContent(),
        [Config.isAgency, Config.clickAndSendSupportURL]
    );
    return (
        <>
            <p>{content.Introduction}</p>
            <p>
                {content.Practices.header}{' '}
                {!Config.isAgency && !!Config.clickAndSendSupportURL && (
                    <a href={Config.clickAndSendSupportURL} target="_blank">
                        Visit our Help Center
                    </a>
                )}
                {isNonEmptyArray(content.Practices.body) && (
                    <ul>
                        {content.Practices.body.map((point) => (
                            <li>{point}</li>
                        ))}
                    </ul>
                )}
            </p>
            {content.UseCases && (
                <p>
                    {content.UseCases.header}
                    <ul>
                        {content.UseCases.body.map((point) => (
                            <li>{point}</li>
                        ))}
                    </ul>
                </p>
            )}
        </>
    );
};
